import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import Link from 'next/link';
import styled from 'styled-components';

export const PaginationWrapper = styled.nav(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing[8],
  marginTop: theme.spacing[32],
  marginBottom: theme.spacing[32],
}));

export const PageLink = styled(Link).withConfig({
  shouldForwardProp: (propName) => propName.toString() !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: theme.spacing[40],
  height: theme.spacing[40],
  padding: `0 ${theme.spacing[12]}`,
  borderRadius: theme.spacing[4],
  border: `1px solid ${isActive ? theme.colors.blue : theme.colors.gray01}`,
  backgroundColor: isActive ? theme.colors.blue : theme.colors.highEmphasisWhite,
  color: isActive ? theme.colors.highEmphasisWhite : theme.colors.highEmphasisBlack,
  textDecoration: 'none',

  '&:hover': {
    borderColor: theme.colors.blue,
    color: isActive ? theme.colors.highEmphasisWhite : theme.colors.blue,
  },
}));

export const PageLinkText = styled(Typography).attrs({
  variant: TextStyles['Heading 5'],
  type: 'span',
})({
  color: 'inherit',
});

export const Ellipsis = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
  type: 'span',
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  padding: `0 ${theme.spacing[4]}`,
}));
